/*
 * @Description: 工程交底接口
 * @Author: wangwangwang
 * @Date: 2020-10-09 11:00:04
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-05-18 10:13:57
 */
import request from "@/utils/request";

export function saveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/saveOrUpdate",
    method: "post",
    data,
  });
}
export function getDisClostInfo(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/getDisClostInfo",
    method: "post",
    data,
  });
}
// 工程交底-委托类型-提交审核
export function validateParameters(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/validateParameters",
    method: "post",
    data,
  });
}
/**
 * 获取登记基础信息
 * @param  {object} data 工程ID
 * @return {[type]}      [description]
 */
export function getDisClostDetail(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/getDisClostDetail",
    method: "post",
    data,
  });
}
/**
 * 获取产品费用列表
 * @param  {object} data 工程ID, type: 0 表示价格，1：调价列表
 * @return {[type]}      [description]
 */
export function getDisClostDisAddCost(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/getDisClostDisAddCost",
    method: "post",
    data,
  });
}
/**
 * 获取配合比
 * @param  {object} data 工程ID
 * @return {[type]}      [description]
 */
export function getDibMatching(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/getDibMatching",
    method: "post",
    data,
  });
}
/**
 * 获取合同附件
 * @param  {object} data 工程ID
 * @return {[type]}      [description]
 */
export function getFiles(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/getFiles",
    method: "post",
    data,
  });
}
/**
 * 获取履约人员信息
 * @param  {object} data 工程ID
 * @return {[type]}      [description]
 */
export function getPersormance(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/getPersormance",
    method: "post",
    data,
  });
}
/**
 * 获取风控维护信息
 * @param  {object} data 工程ID
 * @return {[type]}      [description]
 */
export function getManagement(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/getManagement",
    method: "post",
    data,
  });
}

export function getdisAuth(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/getdisAuth",
    method: "post",
    data,
  });
}
export function updatedisAuth(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/updatedisAuth",
    method: "post",
    data,
  });
}

// 保存基本交底信息
export function saveOrUpdateDisclose(params) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/saveOrUpdateDisclose",
    method: "post",
    data: params,
  });
}
// 工程履约保存基本交底信息
export function updateDisclose(params) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/updateDisclose",
    method: "post",
    data: params,
  });
}

// 保存产品收费
export function saveOrUpdateDisAddCost(params) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/saveOrUpdateDisAddCost",
    method: "post",
    data: params,
  });
}

// // 保存产品配合比
export function saveOrUpdateDibMatching(params) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/saveOrUpdateDibMatching",
    method: "post",
    data: params,
  });
}

// 保存交底附件
export function saveOrUpdateFiles(params) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/saveOrUpdateFiles",
    method: "post",
    data: params,
  });
}

// 保存履约人员
export function saveOrUpdatePersormance(params) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/saveOrUpdatePersormance",
    method: "post",
    data: params,
  });
}

// 保存风控维护信息
export function saveOrUpdateManagement(params) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/saveOrUpdateManagement",
    method: "post",
    data: params,
  });
}

// 修改审批状态
export function UpdatePingGu(params) {
  return request({
   url: "/icps/system/sign/cloudSell/engineeringManagement/UpdatePingGu",
    method: "post",
    data: params,
  });
}
// 保存审批参数
export function saveDiscloseProcess(params) {
  return request({
   url: "/icps/system/sign/cloudSell/disclose/saveDisclosePrrocess",
    method: "post",
    data: params,
  });
}


// 添加调价
export function updateRevisePrice(params) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/updateRevisePrice",
    method: "post",
    data: params,
  });
}

// 删除调价
export function deleteRevisePrice(params) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/deleteRevisePrice",
    method: "post",
    data: params,
  });
}

// 获取调价记录
export function getRevisePrice(params) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/getRevisePriceProduction",
    method: "post",
    data: params,
  });
}
/**2021-01-20云销大改版 */
export function rawMaterialsQueryPage(data) {
  return request({
    url: "/icps/system/sign/basics/rawMaterials/QueryPage",
    method: "post",
    data,
  });
}

/**交底修改记录*/
export function discloseQueryPage(data) {
  return request({
    url: "/icps/system/sign/cloudSell/disclose/QueryPage",
    method: "post",
    data,
  });
}

/**协调主体字典*/
export function get_detail(data) {
  return request({
      url: '/base/system/base/dictionary/get_detail',
      method: 'get',
      params: data
  })
}